import React from 'react';
import { Box, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { parseDomain } from '@wix/domains-serverless-interface';
export const DomainNameError = _ref => {
  let translationKey = _ref.translationKey,
    _ref$args = _ref.args,
    args = _ref$args === void 0 ? {} : _ref$args,
    children = _ref.children;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const _parseDomain = parseDomain((args == null ? void 0 : args.domainName) ?? ''),
    tld = _parseDomain.tld,
    formattedInput = _parseDomain.formattedInput;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    textAlign: "center"
  }, children ? children : translationKey ? /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, t(translationKey, {
    ...args,
    tld: `.${tld}`,
    domainName: formattedInput
  })) : null);
};
//# sourceMappingURL=DomainNameError.js.map